/** @format */
import compRegCenter from '@/common/resource/compRegCenter.json';
import mixedUtils from './utils';
import dynamicCompMixin from './dynamic-comp-mixin';
/**
 *
 */

export default {
  mixins: [dynamicCompMixin],
  template: `
  <TableFilterItem label="客户信息">
  <a-input-group compact style="display:flex">
  <a-select v-model="model[0]" style="width: 100px">
    <a-select-option :key="code" v-for="(cnName,code) in options" :value="code">{{cnName}}</a-select-option>
  </a-select>
  <a-input ref="myInput" style="flex:1"
 
           v-model="model[1]" />
</a-input-group>
          </TableFilterItem>
  `,

  props: {
    ...mixedUtils.generateCompPropsByCompDefine(
      mixedUtils
        .generateNewListByListItemExtendDefine(compRegCenter.items, 'comp', 'extend')
        .find(item => item.comp == 'business-input-group')
    ),
    filterParam: Object,
    compDefine: Object
  },
  mounted() {
    if (process.env.NODE_ENV != 'production') {
      window.BUSINESS_INPUT_GROUP = this;
    }
    mixedUtils.log('pppppppppp:', this.$props);
  },
  methods: {
    // handleInputChange(v) {
    //   console.log('model 1--:', this.model[1])
    //   this.model[1] = v

    //   console.log('this.model--:', this.model)
    // },
    // handleSelectChange(v) {
    //   console.log('model 1--:', this.model[1])
    //   this.model[0] = v

    //   console.log('this.model--:', this.model)
    // },
    clearValue() {
      this.model = this.getClosestVM().lodash.cloneDeep(this.initialValueCopy);
      // this.$refs.myInput.$el.value = this.model[1]
      // this.$refs.myInput.setValue('')
    }
  },
  data() {
    return {
      where: 'UI.TableFilter.items',
      model: this.compDefine.initialValue
    };
  }
};
